<template>
  <div
    class="pieCharts"
    :id="'pieCharts' + randomNumber"
  ></div>
</template>

<script>
export default {
  name: "PieCharts",
  data() {
    return {
      randomNumber: Date.now()
    }
  },
  mounted() {
    this.showCharts();
  },
  methods: {
    // 展示折线图
    showCharts() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('pieCharts' + this.randomNumber));//也可以通过$refs.newCharts的方式去获取到dom实例。
      // 绘制图表
      myChart.setOption({
        color: ['#77c8fa', '#6c74ec', '#91fca3', '#5cc8c8', '#c8fbf8', '#beb166'],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          textStyle: {
            color: '#fff'
          }
        },
        graphic: {       //图形中间图片
          elements: [
            {
              type: 'image',
              style: {
                image: require('@/assets/images/ornament/pieBg.png'),//你的图片地址
                width: 160,
                height: 160
              },
              top: '0.5%',
              left: '40.5%',
            },
            {
              type: 'image',
              style: {
                image: require('@/assets/images/ornament/pie.png'),//你的图片地址
                width: 80,
                height: 80,
              },
              top: '25%',
              left: '53%',
            }
          ]
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['60%', '90%'],
            center: ['65%', '50%'],
            data: [
              { value: 14, name: '打磨面积过小' },
              { value: 12, name: '打磨面积过大' },
              { value: 9, name: '涂胶断胶' },
              { value: 18, name: '涂胶溢胶' },
              { value: 10, name: '喷底精度不足' },
              { value: 37, name: '其它' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            label: {
              show: false
            },
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
.pieCharts {
  width: 330px;
  height: 160px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
